module.exports = __webpack_public_path__ + "static/media/aboutus.8821bfce.webp";